import { Button, Redirect } from '@shopify/app-bridge/actions';
import { getShopifyParams } from '@utils/getShopifyParams';
import { getAppBridgeInstance, getAppBridgeConfig } from '@utils/appBridge';

// Use the same host detection as the main app
const { host } = getShopifyParams();

export const config = host ? getAppBridgeConfig(host) : null;

// Get app instance through the centralized function to avoid duplicates
export const getApp = () => {
  if (!host) {
    console.warn('[app-bridge.tsx] No host available, cannot create app instance');
    return null;
  }
  
  return getAppBridgeInstance(host);
};

export const app = getApp(); // This will be null if no host

export const getRedirect = () => {
  const appInst = getApp();
  return appInst ? Redirect.create(appInst) : null;
};

export const redirect = getRedirect();

export const go = (path: string) => {
  console.log('[app-bridge.tsx] go() called with path:', path);
  const redirectInst = getRedirect();
  if (redirectInst) {
    redirectInst.dispatch(Redirect.Action.APP, path);
  } else {
    console.warn('[app-bridge.tsx] Cannot navigate: no redirect instance available');
  }
};

export const go_remote = (url: string, blank = true) => {
  console.log('[app-bridge.tsx] go_remote() called with url:', url, 'blank:', blank);
  const redirectInst = getRedirect();
  if (redirectInst) {
    redirectInst.dispatch(Redirect.Action.REMOTE, { url: url, newContext: blank });
  } else {
    console.warn('[app-bridge.tsx] Cannot navigate remotely: no redirect instance available');
  }
};

export const getOkButton = () => {
  const appInst = getApp();
  return appInst ? Button.create(appInst, { label: 'Ok' }) : null;
};

export const okButton = getOkButton();
